import {SpinnerContainer, SpinnerOverlay} from './spinner.styles.jsx';

const Spinner = () => (
    <SpinnerOverlay>
        <SpinnerContainer />
    </SpinnerOverlay>
);

export default Spinner;